const o = "loginPage_3Pe-2", l = "loginPage__callToAction_EKj8l", g = {
  loginPage: o,
  loginPage__callToAction: l
};
export {
  g as default,
  o as loginPage,
  l as loginPage__callToAction
};
//# sourceMappingURL=requiresLoginPage.module.scss.js.map
